// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1484":"e9c05e5d","2279":"fc749e97","2472":"8c5d7043","4941":"d6c2bafb","5617":"e9c05e5d","9487":"8c5d7043"}[chunkId] + ".chunk.css";
};